import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { syncContextToReducer } from '../../store/csw/csw.actions';
import { useRateShopper } from '../../pages/settings/rate-shopper/hooks/use-rate-shopper';
import Global from '../../store/global-selectors';
import { PackageService } from '../../services/package-service';

export const useServiceCollection = (fulfillmentPlanId, onConfigurationChange, otherShippingOptions) => {
  const accountPackages = useSelector(Global.selectSellerPackages);
  const { prePopulatePackage, prePopulateConfirmation, requirePackage } = useRateShopper();
  const dispatch = useDispatch();
  const onServiceCollectionChange = useCallback(
    ({ serviceId = null, sellerLabelProviderId = null, serviceCollectionGuid = null }) => {
      onConfigurationChange({ serviceId, sellerLabelProviderId, serviceCollectionGuid }, { doNotCallForRate: true });
      dispatch(
        syncContextToReducer(fulfillmentPlanId, {
          serviceId,
          sellerLabelProviderId,
        }),
      );
    },
    [dispatch, fulfillmentPlanId, onConfigurationChange],
  );

  const onUpdatePackageServiceCollection = useCallback(
    ({ currentPackage, packageTypeId, carrierId, newPackages }) => {
      let packages = [];

      if (requirePackage) {
        packages = newPackages.map((p) => {
          const accountPackage = accountPackages?.find((ac) => ac.isCustom && ac.packageTypeId === p.packageTypeId);
          const isCustom = !!accountPackage;
          return {
            ...p,
            packageId: PackageService.buildCompositePackageId({
              packageTypeId: p.packageTypeId,
              carrierId: isCustom ? accountPackage.carrierId : carrierId,
              isCustom: !!accountPackage,
            }),
            isCustom,
          };
        });
      } else {
        const accountPackage = accountPackages?.find((ac) => ac.isCustom && ac.packageTypeId === packageTypeId);
        const isCustom = !!accountPackage;
        packages = [
          {
            ...currentPackage,
            packageTypeId,
            packageId: PackageService.buildCompositePackageId({
              packageTypeId,
              carrierId: isCustom ? accountPackage.carrierId : carrierId,
              isCustom,
            }),
            isCustom,
          },
        ];
      }

      onConfigurationChange({ packages }, { doNotCallForRate: true });
      dispatch(syncContextToReducer(fulfillmentPlanId, { packages }));
    },
    [accountPackages, requirePackage, dispatch, fulfillmentPlanId, onConfigurationChange],
  );

  const onUpdateConfirmationServiceCollection = useCallback(
    ({ confirmationId }) => {
      const newOptions = {
        ...otherShippingOptions,
        // this seems weird but is true to the previous logic so nothing downstream should change
        confirmation: confirmationId,
        confirmationEnumId: confirmationId,
      };
      onConfigurationChange({ options: newOptions }, { doNotCallForRate: true });
      dispatch(syncContextToReducer(fulfillmentPlanId, { options: newOptions }));
    },
    [dispatch, fulfillmentPlanId, otherShippingOptions, onConfigurationChange],
  );

  return {
    onServiceCollectionChange,
    onUpdatePackageServiceCollection,
    prePopulatePackage,
    prePopulateConfirmation,
    onUpdateConfirmationServiceCollection,
  };
};
